/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Invalid_TableInputs */



/**
* | output |
* | --- |
* | "Invalid table number" |
*
* @param {Err_Tournament_Invalid_TableInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_invalid_table = /** @type {((inputs?: Err_Tournament_Invalid_TableInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Invalid_TableInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Numéro de table invalide")
	if (locale === "es") return /** @type {LocalizedString} */ ("Número de mesa no válido")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Número de mesa inválido")
	if (locale === "it") return /** @type {LocalizedString} */ ("Numero di tavolo non valido")
	return /** @type {LocalizedString} */ ("Invalid table number")
});